import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {CiudadesComponent} from '../ciudades.component';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
//Services
import {CityService} from 'src/app/core/services/parameters/city.service';
import {CountryService} from 'src/app/core/services/parameters/country.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearCiudadModal implements OnInit {

  newCityForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();
  countries = [];
  filteredCountries: Observable<String[]>;

  constructor(
    public dialogRef: MatDialogRef<CiudadesComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private countryService: CountryService,
    private cityService: CityService
  ) {
  }

  ngOnInit(): void {
    this.newCityForm = this.fb.group({
      city: [, Validators.required],
      country: [, Validators.required]
    })
    this.countryService.getAllCountries().subscribe(_res => {
      this.countries = _res
      const countryControl = this.newCityForm.controls.country as FormControl;
      this.filteredCountries = countryControl.valueChanges
        .pipe(
          startWith(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => {
              if (name) {
                const filterValue = name.toLowerCase();
                return this.countries.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
              } else {
                return this.countries.slice()
              }
            })
        )
    })
  }

  displayFn(user): string {
    return user && user.name ? user.name : '';
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newCityForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newCityForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.city,
        countryId: form.value.country.id
      }
      this.cityService.createCity(data).subscribe(_res => {
        this.alert.setNotice('Ciudad creada correctamente', 'success');
        this.showAlert = true;
            this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear la ciudad', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
